export default __webpack_public_path__ + "static/media/Broadcast-white.2ef9071a.svg";